import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import HistoryDataService from '../../../../services/HistoryDataService';
import { componentKey, setIsMemberUserAccessPrePayEnabled, setLoadingState, setPopupPaymentOptions, setRequests, setShowPopupPaymentOptions, setShowPopupPrepayRequest, setTotalRequests } from './W8W9RequestHistorySlice';
import Payer from '../../../../libs/utility/Payer';
import { W8W9_REQUEST_STATE } from './constants';
import General from '../../../../libs/utility/General';

export const { getRequests, updateMemberUserAccess, checkW8W9Payment } = {
    getRequests: (payload) => {
        return {
            type: "W8W9REQUEST/GET_REQUESTS",
            payload: payload
        }
    },
    updateMemberUserAccess: (payload) => {
        return {
            type: "W8W9REQUEST/UPDATE_MEMBER_USER_ACCESS",
            payload: payload
        }
    },
    checkW8W9Payment: (payload) => {
        return {
            type: "W8W9REQUEST/CHECK_W8W9_PAYMENT",
            payload: payload
        }
    },
}

function* getRequestsAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING}));
        const response = yield HistoryDataService.GetW8W9RequestsHistoryDetails(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setRequests([...General.extractDataFromResponseData(response.data)]));
            yield put(setIsMemberUserAccessPrePayEnabled(General.extractDataFromResponseData(response.data).IsMemberUserAccessPrePayEnabled ?? false));
            yield put(setTotalRequests(General.extractPaginationTotalFromResponse(response.data)));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* updateMemberUserAccessAsync(action) {
    try {
        yield put(setLoadingState({ state: W8W9_REQUEST_STATE.ACTIONS_LOADING }));
        const response = yield HistoryDataService.UpdateMemberUserAccess(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: W8W9_REQUEST_STATE.ACTIONS_READY }))
    }
}

function* checkW8W9PaymentAsync(action) {
    try {
        yield put(setLoadingState({ state: W8W9_REQUEST_STATE.PREPAY_LOADING }));
        const response = yield HistoryDataService.checkW8W9Payment({recipientId: 0});
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setShowPopupPrepayRequest(true))
            if(response.data.Data === 'NoPayment') {
                yield put(setShowPopupPaymentOptions(true))
                const paymentsListResponse = yield HistoryDataService.getW8W9Plans()
                if(paymentsListResponse?.data?.Status && paymentsListResponse.data.Status === 1) {
                    const optionsArray = paymentsListResponse?.data?.Data.map(option => ({id: option.id, value: option.Value, label: option.Label}));
                    yield put(setPopupPaymentOptions(optionsArray))
                }
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: W8W9_REQUEST_STATE.PREPAY_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getRequests().type, getRequestsAsync),
        takeLatest(updateMemberUserAccess().type, updateMemberUserAccessAsync),
        takeLatest(checkW8W9Payment().type, checkW8W9PaymentAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);